import EnumSignTimestampLevel from "./gen/qsign/types/EnumSignTimestampLevel";

const labels = {
    [EnumSignTimestampLevel.QUALIFIED]: "Kvalifikovaný",
    [EnumSignTimestampLevel.GUARANTEED]: "Zaručený",
    [EnumSignTimestampLevel.NONE]: "Žádný",
};

export function getCaption(source: EnumSignTimestampLevel) {
    const caption = labels[source];
    return caption ? caption : "[" + source + "]";
}
